import React from "react";
import "./viewer.css";
import { Utils } from "../../js/utils";

//Components
import PlayCanvasComponent from '../playCanvas/playCanvas';

class Viewer extends React.Component {
	constructor(props) {
		super(props);
		// this.fastreload = true;
		this.fastreload = (Boolean(props.isPhone) || props.isiPad || props.isMobileUrl) || false;
		this.toggleSHS = this.toggleSHS.bind(this);
	}

	// toggleSHS(hs_name){
	// 	Object.keys(this.props.hotspot?.Parts || {}).map(partName => {
	// 		if(this.props.hotspot.Parts[partName].PCHotspotName === hs_name)
	// 		{
	// 			this.props.toggleSubHotspot(this.props.hotspot.Parts[partName].Name);
	// 			return;
	// 		}
	// 	})
	// }

	toggleSHS(hs_name){
		this.props.toggleSubHotspot(hs_name);
	}

	render() {
		const breadcrumb = [this.props.hotspot?.ParentTitle, this.props.hotspot?.Title, this.props.subhotspot?.ParentTitle].filter(t => t).join(': ');
		let bgPath = this.props.mode == 'kiosk' ? this.props.hotspot?.KioskBackground : (this.props.subhotspot?.Background || this.props.hotspot?.Background);

		const bg = Utils.getMediaType(bgPath) == 'vid' ? <video className="bg" src={bgPath} playsInline autoPlay loop muted disablePictureInPicture /> : <img className="bg" src={bgPath} />;
		return (
			<>
			<div id="viewer" className={this.props.hotspot && (Object.keys(this.props.hotspot.SubHotspots).length == 0 || this.props.hotspot.Camera) ? '' : 'hide'}>
				{this.props.mode != 'kiosk' && <h1 dangerouslySetInnerHTML={{ __html: breadcrumb }}></h1>}
				{this.props.mode != 'wall' && <div className="close" onClick={this.props.closeViewer}></div>}
				{(!this.props.hotspot?.Model || Boolean(this.props.isPhone) || this.props.isiPad || this.props.isMobileUrl) && bgPath && 
				(<>
				{bg}
					<div className="bg subHS-wrapper">
					{Object.keys(this.props.hotspot?.Parts || {}).map(partName => {
						let hs = this.props.hotspot.Parts[partName];
						let posMode = this.props.mode != 'wall' ? 'web' : 'wall';
						let position = { top: (hs.Top || hs.HotspotPos[posMode].y) * 100 + '%', left: (hs.Left || hs.HotspotPos[posMode].x) * 100 + '%' };
						let subhotspots = this.props.subhotspot?.id == hs.Id ? hs.SubHotspots : (hs.Id == this.props.subhotspot?.ParentId ? (hs.SubHotspots || []).find(shs => shs.Id == this.props.subhotspot?.id)?.SubHotspots || [] : []);
						return hs && <React.Fragment key={'sub-' + partName}> 
						<div className="sub-wrapper" style={position}> 
							<div className={"subHS " + (hs.Title.length <= 8 ? 'short' : hs.Title.length <= 22 ? 'medium' : hs.Title.length <= 36 ? 'long' : 'longer') + (((!this.props.subparent || Object.keys(this.props.subhotspot?.Parts || {}).length > 0) && hs.Title === this.props.copyTitle) || hs.SubHotspots.filter(shs => shs.Title == this.props.copyTitle).length ? ' active' : '') + ((this.props.mode == 'wall' && this.props.copyTitle && hs.Title != this.props.copyTitle && Object.keys(this.props.subhotspot.Parts || {}).length == 0 ? ' hide' : '') || (hs.Filter.some(el => this.props.filter.includes(el)) ? '' : ' hide') || ((this.props.subhotspot && Object.keys(this.props.subhotspot.Parts || {}).length == 0) ? ' hide' : ''))} onClick={e => this.props.togglePart(hs.Name)}>
								{hs.Title}
							</div>
							{
								<ul className={`subparts ${hs.Id !== this.props.subhotspot?.id ? 'hide' : ''}`}>
									{ (hs.Parts || []).map(shs => <li
									key={shs.Id}
									className={"subHS " + (shs.hotspotText.length <= 8 ? 'short' : shs.hotspotText.length <= 22 ? 'medium' : shs.hotspotText.length <= 36 ? 'long' : 'longer') + (this.props.subparent && shs.Id === this.props.subhotspot?.id ? ' active' : '') + ((this.props.mode == 'wall' ? ' hide' : '') || (shs.Filter.some(el => this.props.filter.includes(el)) ? '' : ' hide') || (this.props.mode == 'web' && this.props.subhotspot?.ParentId ? ' hide' : ''))}
									onClick={e => this.props.togglePart(shs.Name, null, hs.Id)}>{shs.Title}</li>) }
								</ul>
							}
						</div>
						{(subhotspots || []).map(shs => 
						<div 
							key={shs.Id}
							className={"subHS " + (shs.hotspotText.length <= 8 ? 'short' : shs.hotspotText.length <= 22 ? 'medium' : shs.hotspotText.length <= 36 ? 'long' : 'longer') + (shs.Id === this.props.subhotspot?.id ? ' active' : '') + ((this.props.mode == 'wall' && this.props.copyTitle && shs.hotspotText != this.props.copyTitle ? ' hide' : '') || (shs.Filter.some(el => this.props.filter.includes(el)) ? '' : ' hide'))}
							style={{top: shs.HotspotPos[posMode].y * 100 + '%', left: shs.HotspotPos[posMode].x * 100 + '%'}}
							onClick={e => this.props.togglePart(shs.Name)}>{shs.hotspotText}
						</div>)}
						</React.Fragment>
					})}
					</div>
				</>)
				}
				{!this.fastreload && <PlayCanvasComponent mode={this.props.mode} hotspot={this.props.hotspot} subhotspot={this.props.subhotspot} pcLoading={this.props.pcLoading} toggleSHS={this.toggleSHS} filter={this.props.filter} pcHotspotsVisibility={this.props.pcHotspotsVisibility}/>}
			</div >
			{this.props.mode != 'kiosk' && <div id="copyPane" className={this.props.copyText || !this.props.subhotspot && this.props.hotspot?.Copy ? '' : 'hide'}>
				<h1 id="subTitle" dangerouslySetInnerHTML={{ __html: this.props.copyText && this.props.copyTitle || !this.props.subhotspot && this.props.hotspot?.Copy && this.props.hotspot?.Title || ''}}></h1>
				<p dangerouslySetInnerHTML={{ __html: this.props.copyText || !this.props.subhotspot && this.props.hotspot?.Copy || ''}}></p>
			</div>}
			</>
		);
	}
}

export default Viewer;
